import type { LoaderVariant } from "@context/LoadingContext";
import styles from "./GlobalLoaderOverlay.module.scss";

type LoaderSize = "small" | "medium" | "large";

interface GlobalLoaderConfigInput {
  isInApp: boolean;
  loadingText: string;
  requestedVariant: LoaderVariant;
  defaultSize: LoaderSize;
}

interface GlobalLoaderConfig {
  variant: LoaderVariant;
  size: LoaderSize;
  text: string;
  overlayClassName: string;
  textClassName: string;
}

export const resolveGlobalLoaderConfig = ({
  isInApp,
  loadingText,
  requestedVariant,
  defaultSize,
}: GlobalLoaderConfigInput): GlobalLoaderConfig => {
  if (isInApp) {
    return {
      variant: "lottie",
      size: defaultSize,
      text: "",
      overlayClassName: styles.whiteOverlay,
      textClassName: "",
    };
  }

  if (requestedVariant === "valuation") {
    return {
      variant: "valuation",
      size: "small",
      text: loadingText,
      overlayClassName: styles.whiteOverlay,
      textClassName: styles.darkText,
    };
  }

  return {
    variant: requestedVariant,
    size: defaultSize,
    text: loadingText,
    overlayClassName: "",
    textClassName: "",
  };
};
